import { SourceSystem } from "src/app/models/enums";

export class OrderShipmentSelection {
  orderNumber: number;
  shipmentNumber: number;
  sourceSystem: SourceSystem; // SGC or ADEBS
}
